import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { leaveApi } from "../../services/leaveApi";
import { PageHelpBanner } from "../../components/PageHelpBanner";
import { useLocalization } from "../../hooks/useLocalization";

export default function MyLeavePage() {
  const navigate = useNavigate();
  const { t } = useLocalization();
  const [balance, setBalance] = useState(null);

  useEffect(() => { leaveApi.myBalance().then((r) => setBalance(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-5" data-testid="my-leave-page">
      <PageHelpBanner pageKey="my-leave" title={t("pageHelp.defaultTitle")}>
        <p>{t("pageHelp.myLeave")}</p>
      </PageHelpBanner>
      <div>
        <h2 className="text-xl font-bold tracking-tight text-gray-900">{t("myLeave.title")}</h2>
        <p className="text-sm text-gray-500">{t("myLeave.subtitle")}</p>
      </div>

      {balance && (
        <div className="bg-white border border-gray-200 rounded-xl p-6 text-center" data-testid="my-leave-balance-card">
          <p className="text-4xl font-bold text-gray-900" data-testid="my-leave-balance-value">{balance.current_balance}</p>
          <p className="text-xs text-gray-500 mt-1">{t("myLeave.daysAvailable")}</p>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">
        <button data-testid="my-leave-history-btn" onClick={() => navigate("/employee/leave/history")} className="bg-white border border-gray-200 rounded-xl p-4 text-left hover:border-blue-400 transition-colors">
          <p className="text-sm font-semibold text-gray-800">{t("myLeave.historyTitle")}</p>
          <p className="text-xs text-gray-500">{t("myLeave.historySubtitle")}</p>
        </button>
        <button data-testid="my-leave-requests-btn" onClick={() => navigate("/employee/leave/requests")} className="bg-white border border-gray-200 rounded-xl p-4 text-left hover:border-blue-400 transition-colors">
          <p className="text-sm font-semibold text-gray-800">{t("myLeave.requestsTitle")}</p>
          <p className="text-xs text-gray-500">{t("myLeave.requestsSubtitle")}</p>
        </button>
        <button data-testid="my-leave-mandatory-use-btn" onClick={() => navigate("/employee/leave/mandatory-use")} className="bg-white border border-gray-200 rounded-xl p-4 text-left hover:border-blue-400 transition-colors col-span-2">
          <p className="text-sm font-semibold text-gray-800">{t("myLeave.mandatoryUseTitle")}</p>
          <p className="text-xs text-gray-500">{t("myLeave.mandatoryUseSubtitle")}</p>
        </button>
      </div>

      {balance && (
        <div className="bg-white border border-gray-200 rounded-xl p-4 grid grid-cols-2 gap-3 text-sm" data-testid="my-leave-balance-breakdown">
          <p><span className="text-gray-500">{t("myLeave.granted")}:</span> {balance.granted_total}</p>
          <p><span className="text-gray-500">{t("myLeave.used")}:</span> {balance.used_total}</p>
          <p><span className="text-gray-500">{t("myLeave.futureReserved")}:</span> {balance.future_reserved_total}</p>
          <p><span className="text-gray-500">{t("myLeave.expired")}:</span> {balance.expired_total}</p>
        </div>
      )}
    </div>
  );
}
